import log from "loglevel";

export enum LocalStorageItems {
    CART = "warenkorb",
    CUSTOMER = "customer",
    BOOKMARK = "merkliste",
    CAPTCHA = "captcha",
}

export enum LocalStorageItemsLastUpdated {
    CARTLASTUPDATED = "warenkorbLastUpdated",
    CUSTOMERLASTUPDATED = "customerLastUpdated",
    BOOKMARKLASTUPDATED = "bookmarkLastUpdated",
    CAPTCHALASTUPDATED = "captchaLastUpdated",
}

export type LocalStorageLastUpdated = {
    [key in LocalStorageItemsLastUpdated]?: number;
};

export default interface LocalStorageProviderProps {
    logger?: log.RootLogger;
}